import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Expo_Village.webp';

const Project_one = () => {

  return (
    <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>Expo Village</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>The residential accommodation campus built for Expo 2020 Dubai participants, subsequently converted into a permanent
                    mixed-use residential community as part of the Expo City legacy development — one of the UAE's most significant post-event
                    urban repurposing initiatives.</p>
                  <p>MAIN CONTRACTOR : -</p>
                  <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                  <p>GEMCO SCOPE OF WORKS : CHW and LPG works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>

  )
}

export default Project_one